export const SET_RIDER_LIST = 'set-rider-list';
export const SET_SPECIFIC_RIDER_DATA = 'set-sepcific-rider-data';
export const SET_EDIT_RIDER_ID = 'set-edit-rider-id';
